// table-row — default skin module (RUN-407: native table redesign)
// run-table-row is a configuration node. run-table's skin renders native <tr>/<td>
// elements directly and projects run-table-cell content via manual slot assignment.
// This component provides light-DOM structure; its host is hidden from layout.

export const styles = `
  :host {
    display: none;
  }
`;

export function render(host) {
  host.shadowRoot.innerHTML = `<slot></slot>`;
}
